const changeValue = (variable, dispatch, funtionDispatch) => {
  return ({ id, value }) => {
    const payload = {
      id,
      value: Number(value),
      variable,
    }
    dispatch(funtionDispatch(payload))
  }
}

const changeValueSliderRange = (id, variable, dispatch, funtionDispatch) => {
  return () => {
    const inputSlider = document.getElementById(id).children[2]
    const { value } = inputSlider
    const payload = {
      id,
      value: Number(value),
      variable,
    }
    dispatch(funtionDispatch(payload))
  }
}

export { changeValue, changeValueSliderRange }
